export default function BrandStory() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-10 max-w-4xl">
        <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-200 text-secondary-800 text-xs font-semibold mb-8 whitespace-nowrap">
          品牌故事
        </span>

        <h2 className="text-3xl md:text-4xl font-bold font-heading text-foreground-950 leading-tight mb-8">
          从吃瓜群众到<br />专业吃瓜第一站
        </h2>

        <div className="space-y-6">
          <p className="text-base text-foreground-700 leading-loose">
            2024年初，一群热爱娱乐八卦的年轻人聚在一起，发现了一个共同痛点：想要快速了解最新的娱乐八卦和明星动态，却要在各个平台间反复切换。信息分散、真假难辨、更新不及时，吃瓜体验大打折扣。
          </p>
          <p className="text-base text-foreground-700 leading-loose">
            于是，黑料吃瓜网诞生了。我们聚合全网最热门的娱乐资讯，通过专业的内容审核团队确保每一条爆料的真实性和时效性。从最初的几十个用户到如今数百万吃瓜群众的每日必访，我们始终坚持一个信念：<strong>让吃瓜变得更简单、更有趣、更真实。</strong>
          </p>
          <p className="text-base text-foreground-700 leading-loose">
            今天，黑料吃瓜网已经成长为国内领先的娱乐八卦资讯聚合平台。我们拥有专业的编辑团队、完善的爆料审核机制和活跃的吃瓜社区。每日不间断更新，用最快的速度传递最新鲜的瓜。
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mt-12">
          <div className="text-center p-4 md:p-6 rounded-xl bg-background-50">
            <div className="text-2xl md:text-3xl font-bold text-accent-600 mb-1">500万+</div>
            <div className="text-xs text-foreground-500">日活跃用户</div>
          </div>
          <div className="text-center p-4 md:p-6 rounded-xl bg-background-50">
            <div className="text-2xl md:text-3xl font-bold text-accent-600 mb-1">10万+</div>
            <div className="text-xs text-foreground-500">累计爆料</div>
          </div>
          <div className="text-center p-4 md:p-6 rounded-xl bg-background-50">
            <div className="text-2xl md:text-3xl font-bold text-accent-600 mb-1">24h</div>
            <div className="text-xs text-foreground-500">全天候更新</div>
          </div>
          <div className="text-center p-4 md:p-6 rounded-xl bg-background-50">
            <div className="text-2xl md:text-3xl font-bold text-accent-600 mb-1">99.8%</div>
            <div className="text-xs text-foreground-500">内容真实率</div>
          </div>
        </div>
      </div>
    </section>
  );
}